export const valid = {
    descriptions: "between:3,500,string",
    note: "max:500,string",
    reason: "between:3,500,string",
    comments: "between:3,500,string",
}